export function getGraphqlEndpoint() {
  if (window.location.host === "staging-ops.primary.tech") {
    return "https://staging-papi2.primary.tech/graphql";
  } else if (window.location.host === "ops.primary.tech") {
    return "https://papi2.primary.tech/graphql";
  } else if (window.location.host.startsWith("localhost")) {
    return "http://localhost:3005/graphql";
  }
  throw new Error(`unexpected host ${window.location.host}`);
}
